import type { ChatEvent } from '@wundo/shared/chat.ts';

/**
 * Whether this is one of the events a conversation is carried on in.
 *
 * Asked of everything that arrives on a socket, wherever a conversation is
 * being read — the chat drawer and a written practice conversation both — so
 * neither has to guess at a shape it does not know.
 */
export function isChatEvent(
  data: Record<string, unknown>,
): data is ChatEvent & Record<string, unknown> {
  if (data.type === 'typing') {
    return typeof data.conversation_id === 'string';
  }

  if (data.type === 'delta') {
    return (
      typeof data.conversation_id === 'string' &&
      typeof data.message_id === 'string' &&
      typeof data.text === 'string'
    );
  }

  if (data.type === 'activity') {
    return (
      typeof data.conversation_id === 'string' &&
      typeof data.step_id === 'string' &&
      typeof data.text === 'string' &&
      (data.phase === 'start' || data.phase === 'done' || data.phase === 'failed')
    );
  }

  return (
    data.type === 'message' && typeof data.message === 'object' && data.message !== null
  );
}
